import Single from './single'
export * from './multi'

export default Single